import { AdornisRouter } from '@adornis/base/client/a-router';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element';
import { DataLoadingController } from '@adornis/chemistry/controllers/data-loading-controller';
import { ObservableController } from '@adornis/chemistry/controllers/observable-controller';
import { SizeController } from '@adornis/chemistry/controllers/size-controller';
import { css } from '@adornis/chemistry/directives/css';
import '@adornis/chemistry/elements/components/x-grid';
import '@adornis/chemistry/elements/components/x-loading-state';
import '@adornis/germanium/components/ge-button';
import '@adornis/germanium/components/ge-input';
import '@adornis/germanium/components/ge-loading-state';
import '@adornis/germanium/components/ge-section';
import { Ghost } from '@adornis/ghost/db/ghost';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';
import { from } from 'rxjs/internal/observable/from';
import '../components/wtg-blog-post-preview';
import '../components/wtg-footer';
import '../components/wtg-post';

@customElement('wtg-blog')
export class WTGBlog extends ChemistryLitElement {
  size = new SizeController(this);

  @state() postID = new ObservableController(this, AdornisRouter.get('postID'));
  @state() posts = new DataLoadingController(this, () =>
    from(
      Ghost.getAllPosts(
        'publishedAt',
        true,
        10,
        'published',
      )(`{_id id createdAt slug title featureImage published excerpt}`),
    ),
  );

  public render() {
    if (this.postID.value) return html`<wtg-post></wtg-post>`;
    if (this.posts.isLoading) return html` <ge-loading-state ${css({ height: '80vh' })}></ge-loading-state>< `;
    return html`
      <x-flex space="xl">
        <ge-section>
          <x-flex space="lg" ${css({ marginTop: this.size.isMobile ? '200px' : '100px' })}>
            <x-flex space="lg" ${css({ maxWidth: this.sizes.maxReadableWidth })}>
              <ge-h1> Blog </ge-h1>
              <ge-h4> Introduction Text to Blog. </ge-h4>
            </x-flex>
            <x-grid auto-fill-columns="314px" space="md" ${css({ width: '100%' })}>
              ${repeat(
                this.posts.value!,
                post =>
                  html`
                    <wtg-blog-post-preview
                      .postID=${post.id}
                      .header=${post.title}
                      .text=${post.excerpt}
                      .imageUrl=${post.featureImage}
                    ></wtg-blog-post-preview>
                  `,
              )}
            </x-grid>
          </x-flex>
        </ge-section>

        <wtg-footer></wtg-footer>
      </x-flex>
    `;
  }
}
